<template>
  <el-card
    :body-style="{ padding: '10px', height: 'calc(100% - 20px)' }"
    shadow="hover"
    style="height: 100%; border-width: 5px;"
    :class="{ flagged: card.starred }"
  >
    <!-- 图片和内容区域 -->
    <div style="height: 100%; display: flex; gap: 10px; flex-direction: column;">
      <!-- 图片 -->
      <el-image
        :src="card.pageShow ? imageUrl(card.name, 1) : ''"
        :preview-src-list="[imageUrl(card.name)]"
        fit="cover" lazy
        style="height: 100%; aspect-ratio: 1/1;"
      >
        <div slot="placeholder" class="image-slot">
          <i class="el-icon-loading"></i>
          Loading<span class="dot">...</span>
        </div>
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>

      <!-- 右侧内容 -->
      <div style="flex: 1; display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
        <!-- 按钮和标题 -->
        <!-- <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 5px;"> -->
          <!-- <el-tag class="how-tag" size="large"> {{ card.how }} </el-tag> -->
          <!-- <span style="font-weight: bold;">{{ card.how }}</span> -->
          <!-- <span v-if="!onlyShowHow" style="font-weight: bold;">{{ card.what }}</span> -->
          <!-- <span v-if="!onlyShowHow" style="font-weight: bold;">{{ card.why }}</span> -->
          <!-- <span v-if="onlyShowHow" >{{ card.dist }}</span> -->
          <el-rate
            v-if="onlyShowHow"
            disabled
            :value="recLevel"
            :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
            disabled-void-color="rgb(225,225,225)">
          </el-rate>
          <div style="padding-top: 0;">
            <el-button
              type="primary"
              icon="el-icon-search"
              circle
              @click="recommendByImage(card.name)"
              size="mini"
            ></el-button>
            <!-- <el-button
              type="warning"
              :icon="card.starred ? 'el-icon-star-on' : 'el-icon-star-off'"
              :plain="!card.starred"
              circle
              @click="starImage(card.name)"
              size="mini"
            ></el-button> -->
          </div>
        <!-- </div> -->
        <!-- <span v-if="!onlyShowHow" style="margin-bottom: 10px;" >{{ card.dist }}</span> -->

        <!-- 文字内容 -->
        <!-- <div style="flex: 1; overflow-y: auto;">
          <span>{{ card.explain['description'] }}</span>
        </div> -->
      </div>
    </div>
  </el-card>
</template>

<style>
  .el-header {
    background-color: #d7dee7;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }

  .flagged {
    /* background-color: rgb(234, 231, 169); */
    border-color: rgb(234, 231, 169);
    /* border-width: 5px; */
  }

  .diff {
    background-color: rgb(248, 146, 146);
    /* border-color: rgb(248, 146, 146);
    border-width: 5px; */
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>

<script>
import axios from 'axios';
export default {
    name: 'ImageSimple',
    props: {
        cardInit: {
            type: Object,
            default: () => {},
        },
        onlyShowHow: {
            type: Boolean,
            default: true,
        },
    },
    watch: {
        cardInit: {
            handler: function(val) {
                this.card = val;
            },
            immediate: true,
        },
    },
    data() {
        const rootNames = {
            'Why': 'Why (隐喻的目的)',
            'What': 'What (隐喻的本体，数据语义)',
            'How': 'How (隐喻的映射方式)',
        }
        return {
            rootNames: rootNames,
            rootKeys: Object.keys(rootNames),
            infoVisible: false,
            dialogInfo: {
                anno: {},
            },
            user: '',
            annoInput: '',
            editVisible: false,
            editImageUrl: '',
            editInput: '',
            editName: '',
            card: this.cardInit,
        }
    },
    computed: {
      recLevel() {
        if (this.card.level) return this.card.level;
        const averageDist = (this.card.dist.reduce((a, b) => a + b, 0) / this.card.dist.length);
        if (averageDist < 0.15) return 5;
        if (averageDist < 0.25) return 4;
        if (averageDist < 0.3) return 3;
        if (averageDist < 0.4) return 2;
        return 1;
      },
    },
    methods: {
      imageUrl(name, thumb=0) {
        return '/api/image?name=' + name + (thumb ? '&thumb=1' : '');
      },
      recommendByImage(name) {
        this.$message({
          message: 'Recommend similar images as ' + name + ' to user',
          type: 'info'
        });
        this.$emit('recommend', name, this.card);
      },
      // edit card
      handleCardEdit(name) {
        const that = this;
        axios.post('/api/imageinfo', {name: name}).then(function(response) {
          console.log(response.data);
          that.dialogInfo = {
            name: name,
            url: that.imageUrl(name),
            coding: response.data.coding,
            anno: response.data.anno,
            title: response.data.title,
            description: response.data.description,
            keywords: response.data.keywords,
          };
          that.editInput = JSON.stringify(that.card.design, null, 2);
          that.editVisible = true;
          that.editImageUrl = that.imageUrl(name);
          that.editName = name;
        });
      },
      handleDelete(name) {
        this.$emit('delete', name);
      },
      fastAnno(name) {
        // copy this.coding[name] to tmp
        const tmp = JSON.parse(JSON.stringify(this.card.design));
        if (tmp['What'].length === 1 && tmp['What'][0] === '') {
          tmp['What'] = ['领域语义'];
          tmp['How'] = ['形状映射'];
          tmp['Why'] = ['主题'];
        } else if (tmp['What'].length === 1 && tmp['What'][0] === '动态语义') {
          tmp['What'] = ['关系语义'];
        } else {
          this.$message({
            message: '不是空的，不可快速标注',
            type: 'warning',
            duration: 3000,
          });
          return;
        }
        this.$message({
            message: '快速标注成功',
            type: 'info',
            duration: 3000,
        });
        this.editInput = JSON.stringify(tmp, null, 2);
        this.editName = name;
        this.saveEdit();
      },
      // star image
      starImage(name) {
        // const that = this;
        // axios.post('/api/imagestar', {
        //   name: name,
        // }).then(function(response) {
        //   // console.log(response.data);
        //   let stars = response.data.stars;
        //   that.card.starred = stars.includes(name);
        //   that.$message({
        //       message: that.card.starred?'收藏成功':'取消收藏成功',
        //       type: 'success',
        //       duration: 3000,
        //   });
        // });
        const stars = JSON.parse(localStorage.getItem('stars') || '[]');
        if (stars.includes(name)) {
          stars.splice(stars.indexOf(name), 1);
        } else {
          stars.push(name);
        }
        localStorage.setItem('stars', JSON.stringify(stars));
        this.card.starred = stars.includes(name);
        this.$message({
            message: this.card.starred?'收藏成功':'取消收藏成功',
            type: 'success',
            duration: 3000,
        });
        this.$emit('starChanged');
      },
      handleRecover(name) {
        this.$emit('recover', name);
      },
      // click card show detail
      handleClickCard(name) {
        // console.log(name);
        const that = this;
        axios.post('/api/imageinfo', {name: name}).then(function(response) {
          // console.log(response.data);
          that.dialogInfo = {
            name: name,
            url: that.imageUrl(name),
            coding: response.data.coding,
            anno: response.data.anno,
            title: response.data.title,
            description: response.data.description,
            keywords: response.data.keywords,
          };
          if (that.user in that.dialogInfo.anno) {
            that.annoInput = that.dialogInfo.anno[that.user];
          } else {
            that.annoInput = '';
          }
          that.infoVisible = true;
        });
      },
      // annotate images
      saveAnno() {
        const that = this;
        if (that.annoInput === '') {
          return;
        }
        axios.post('/api/imageanno', {
          name: that.dialogInfo.name,
          user: that.user,
          anno: that.annoInput,
        }).then(function(response) {
          // console.log(response.data);
          that.dialogInfo.anno = response.data;
        });
      },
      searchAnno() {
        const that = this;
        if ((that.user in that.dialogInfo.anno) && that.annoInput === '') {
          that.annoInput = that.dialogInfo.anno[that.user];
        }
      },
      // set flag
      setFlag(flag) {
        const that = this;
        axios.post('/api/imageflag', {
          name: that.dialogInfo.name,
          flag: flag,
        }).then(function() {
          // console.log(response.data);
          that.$message({
              message: flag===1?'标记成功':'去除标记成功',
              type: 'success',
              duration: 3000,
          });
          that.card.flagged = flag===1;
        });
      },
      saveEdit() {
        const that = this;
        axios.post('/api/codingedit', {
          name: that.editName,
          coding: JSON.parse(that.editInput),
        }).then(function(response) {
          if (response.data.success) {
            that.$message({
                message: '修改成功',
                type: 'success',
                duration: 3000,
            });
            that.card.design = JSON.parse(that.editInput);
            that.editVisible = false;
            console.log(that.card.design);
          } else {
            that.$message({
                message: '修改失败: ' + response.data.message,
                type: 'error',
                duration: 3000,
            });
          }
        });
      },
    },
    mounted() {
      // console.log(this.card);
    }
};
</script>